import * as ReactDOM from "react-dom";
import * as React from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import "react-loading-skeleton/dist/skeleton.css";
import "./fonts.css";

import App from "./App";

library.add(fas);

ReactDOM.render(<App />, document.getElementById("app"));

window.addEventListener(
    "dragover",
    function (e) {
        e.preventDefault();
        // e = e || event;
        // if (e.target?.classList?.value?.indexOf("accept-drop") == -1) {
            
        // }
    }
);
// window.addEventListener(
//     "drop",
//     function (e) {
//         e = e || event;
//         if (e.target?.classList?.value?.indexOf("accept-drop") == -1) {
//             console.log("drop prevented")
//             e.preventDefault();
//         }
//     },
//     false
// );
